import GetTicketList from './GetTicketList'

export default {
  namespaced: true,
  modules: {
    GetTicketList
  }
}
